<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <!-- Password updated success modal -->
    <ng-container *ngIf="modalType == 'passwordUpdatedSuccess'">
      <img
        class="modal-success-icon"
        src="/assets/icons/success-modal-icon.png"
        alt=""
      />
      <h1 class="label-title">Updated Successfully</h1>
      <h3>Your password has been updated successfully.</h3>
      <button
        (click)="backToProfile()"
        class="modal-button"
        gbui-button
        type="submit"
      >
        Back To Profile
      </button>
    </ng-container>
    <!-- Profile updated success modal -->
    <ng-container *ngIf="modalType == 'profileUpdatedSuccess'">
      <img
        class="modal-success-icon"
        src="/assets/icons/success-modal-icon.png"
        alt=""
      />
      <h1 class="label-title">Updated Successfully</h1>
      <h3>Your profile has been updated successfully.</h3>
      <button
        (click)="closeModal()"
        class="modal-button"
        gbui-button
        type="submit"
      >
        Back To Profile
      </button>
    </ng-container>
  </div>
</div>
